import React from 'react';
import cn from 'classnames';

import { CloseClear } from '../../../Icons';
import { useTheme } from '../../../theme';

interface Props {
	className?: string;
	onClick?: () => void;
}

const Close: React.FC<Props> = ({ className, onClick }) => {
	const { Close: theme } = useTheme('CheckoutAdditionalService');

	return (
		<div className={cn(theme.close, className)} onClick={onClick}>
			{CloseClear}
		</div>
	);
};

export default Close;

export const closeRender = (onClick: () => void) => {
	return <Close onClick={onClick} />;
};
